import React from "react";
import { HashRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout } from "../auth/authActions";

import { NotificationProvider } from "../notifications";
import Header from "../common/template/header";
import SideBar from "../common/template/sideBar";
import Messages from "../common/msg/messages";
import Routes from "./routes";
import MapaRouteSync from "../fase/mapaRouteSync";

const App = ({ user, logout }) => (
  <HashRouter>
    <div className="wrapper">
      <MapaRouteSync />
      <NotificationProvider>
        <Header user={user} logout={logout} />
      </NotificationProvider>
      <SideBar />
      <Routes />
      <Messages />
    </div>
  </HashRouter>
);

const mapStateToProps = (state) => ({ user: state.auth.user });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
